import { useEffect, useRef } from 'react';
/**
 * Perform a callback on each intervals delay.
 *
 * For example:
 * ```typescript
 * // With a constant delay
 * useInterval(() => {
 *     setCount(count + 1);
 * }, 1000);
 *
 * // With an interval that can be paused:
 * useInterval(() => {
 *     setCount(count + 1);
 * }, isRunning ? delay : undefined);
 * ```
 *
 * Note: This hook was written with reference to https://overreacted.io/making-setinterval-declarative-with-react-hooks/
 */ export const useInterval = (callback, delay)=>{
    const savedCallback = useRef(callback);
    const tick = ()=>savedCallback.current()
    ;
    useEffect(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    useEffect(()=>{
        if (delay !== undefined) {
            const id = setInterval(tick, delay);
            return ()=>clearInterval(id)
            ;
        }
    }, [
        delay
    ]);
};
